export default {
    // ----------Title----------
    proformaSales: '形式销售',
    salesCreditNote: '销售贷记单',
    replacementDelivery: '替换交货',
    retailCashSale: '零售收银',
    purchaseOrder: '采购订单',
    purchaseReturn: '采购退货',
    purchaseInvoice: '采购发票',
    deliveryTrips: '送货行程',
    pickOrders: '拣货单',
    itemReceive: '签收货物',
    itemTransfer: '物品转移',
    itemRelocate: '物品迁移',
    itemIssue: '物品问题',
    itemAdjustment: '物品调整',
    itemTransform: '物品转换',
    stockTake: '核对库存',
    executeStockTake: '执行核对库存',
    transferReturn: '调拨退货',
    transferRequisition: '调拨申请',
    retailPrescription: '零售处方',
    document: '文件',
    generateFromDeliveryOrders: '创建(送货单生成)',
    scopeTheRangeOfTheCustomerProfiles: '确定客户档案的范围',
    dateRange: '日期范围',
    documentDateforDeliveryOrders: '交货单的文件日期',
    generateFromContainer: '创建签收(货柜生成)',
    basicInformationAboutTheDocument: '文件基本信息',

    cashCollection: '现金收款',
    optionalForCollectionUponDelivery: '可选择送货时付款',
    hubDistribution: '中心分发',
    deliveryDistributionLocations: '交货分发地点',
    relatedProfilesAttachedToDocument: '附带文件的相关档案',
    relatedWarehouseLocationToProcess: '处理仓库相关位置',
    relatedProfilesToProcess: '处理相关档案',
    relatedDocs: '相关文件',
    relatedDocument: '相关文件',
    relatedDocumentAttached: '附上相关文件',

    approvalStatus: '审核状态',
    relatedProfileInfoAttachedToDocument: '附带文件的相关文件',
    documentNo: '文件号',
    trackingNo: '追踪号',
    collection: '收集',
    distributeVia: '分配',
    placeBy: '下单',
    delivery: '派送至',
    detailInformationAboutTheItemsInvolved: '物品详细信息',
    generateSingleInvoice: '生成单张发票',
    fromContainer: '货柜',
    detailInformationAboutTheDocumentsInvolved: '相关文件的详细资料',
    detailInformationAboutTheDocumentItemsInvolved: '相关文件物品的详细资料',
    loadFromDocuments: '从文档加载',

    payment: '付款',
    relatedPaymentAttachedToDocument: '已附文件相关付款',
    chooseTypes: '选择类型',
    paymentMethod: '付款方式',
    paymentType: '付款类型',
    payerName: '付款人名字',
    receivedAmount: '收款金额',
    orderAmount: '订单金额',
    suppliedBy: '供应商',
    logistic: '运输',
    driver: '送货员',

    memberProfile: '会员信息',
    privateNote: '私人备注',
    itemInformation: '物品信息',
    savedVerifedOut: '已保存且已验证',
    savedData: '已保存数据',
    usage: '使用',
    youHaveNotSelectAnyInventoryYet: '您还未选择任何库存',

    relocateFromNormalRacks: '从普通货架重新调整',
    relocateFromReservedRacks: '从预留货架重新调整',
    transformToDefaultUom: '转换为默认计量单位',

    // -----------Drawer---------
    noPreviewInformation: '无预览信息',
    previewCharges: '预览信息',
    no: '序号',
    item: '物品',
    particulars: '具体内容',
    itemRate: '物品评级',
    chargeAmount: '收费金额',
    shippingRates: '运费率',
    totalSelected: '已选总数',
    documents: '文件',
    generateInvoiceNow: '生成发票',
    savedValidation: '已保存验证',
    newValidation: '添加验证',
    addNewValidation: '添加新验证',
    viewSavedValidation: '查看已保存验证',
    validationSaved: '验证已保存',
    inventory: '库存',
    slot: '槽位',
    rack: '货架',
    availableQty: '可用数量',
    batchNo: '批号',
    expiryDate: '截止日期',
    storage: '存储',
    selectAvailableInventory: '选择可用库存',
    metricType: '度量类型',

    // -----------MUI-----------
    loadFrom: '导入自。。。',
    relocateThreshold: '调整阈值',
    defaultUom: '默认计量单位',
    docNo: '文件号',
    docNumber: '文件号',
    docDate: '文件日期',
    invoiceNo: '发票号',
    billingName: '付款人名称',
    billingAddress: '付款人地址',
    date: '日期',
    validation: '验证',
    generateFromDO: '创建(送货单生成)',
    documentDateFrom: '文件日期(从)',
    documentDateTo: '文件日期(至)',
    startQuery: '开始查询',
    code: '编码',
    qty: '数量',
    billTo: '账单至',
    shipTo: '发货至',
    subTotal: '小计',
    total: '总共',
    tax: '税',
    roundOffAmount: '金额调整',
    appliedTax: '税务项目',
    discount: '折扣',
    taxAmount: '税金额',
    totalAmount: '总金额',
    requiredAmount: '所需金额',
    collectedAmount: '已收集金额',
    distributionLocation: '配送地点',
    generateInvoices: '生成发票',
    marking: '唛头',
    validated: '已审核',
    pending: '待处理',
    balance: '平均',
    uom: '计量单位',
    itemName: '物品名称',
    editDocument: '编辑文件',
    printPreview: '打印预览',
    dimension: '尺寸 (宽x高x长)',
    addItem: '添加物品',
    customer: '客户',
    required: '需要',
    completed: '已完成',
    amount: '金额',
    cost: '成本',
    lastValidated: '验证时间',
    validateIn: '签收验证',
    validateOut: '验证出货',
    fromLocation: '地点出发',
    locationTo: '目的地',
    strictMode: '模式',
    execute: '执行',

    deductQty: '扣除数量',
    verifiedAt: '验证于',
    verifiedBy: '验证者',
    savedQty: '保存数量',
    action: '动作',
    batchNumber: '批号',
    totalQty: '总数量',
    confirmedAt: '确认于',
    markAsConfirm: '标记为确认',
    recipient: '收件人',
    regions: '地区',
    completion: '完成',
    yesIveConfirmed: '是的，我已确认',
    from: '从',
    to: '到',
    normal: '普通',
    reserved: '预留',
    storageFrom: '储存从',
    toStorage: '储存至',
    increase: '增加',
    decrease: '减少',
    itemCode: '物品编码',
    selectedItems: '已选物品',
    transformTo: '转换至',
    availableInventory: '可用库存',

    currentPreview: '当前预览',
    suggestion: '建议',
    noAction: '无操作',
    actions: '操作',
    adjustment: '调整',
    issue: '问题',
    selectedInventoryQty: '已选库存数量',
    customFinalQty: '自定义最终数量',
    finalQty: '最终数量',
    transformInto: '转换',
    allocation: '分配',
    newBatchNo: '新批号',
    modifySelection: '修改选择',
    consumption: '消耗',
    selectInventory: '选择库存',

    receiveQty: '接收数量',
    remainQty: '剩余数量',
    brand: '品牌',
    stockValue: '库存价值',

    trackBatchReceives: '跟踪批次接收',
    stockPosted: '库存已登记',
    posted: '已发布',
    orderedBy: '订购者',
    requiredQty: '所需数量',

    reference: '参考',
    receivableAmount: '应收金额',
    change: '余额',

    importDataSets: '导入数据集',
    downloadFormat: '下载格式',
    importedRows: '导入行列',
    totalStockTakeQty: '库存盘点总数量',
    itemId: '物品编号',
    stockTakeQty: '库存盘点数量',
    uomName: '计量单位名称',
    uomId: '计量单位编号',

    searchPickDocuments: '搜索拣货文件',
}